export default "__VITE_ASSET__BtyZ669J__"